import Cookies from "../../libs/js-cookie/src/js.cookie";

var forEach = function( array, callback, scope ) {
	for ( var i = 0; i < array.length; i++ ) {
		callback.call( scope, i, array[i] ); // passes back stuff we need
	}
} // forEach

class PromoBanner {
	constructor() {
		this.promoCheck();
	}

	promoCheck() {

		const promos = document.querySelectorAll( '.promo-footer' );
		var promo_id;
		var promo_cookie;
		var dismiss_button;
		var dismiss_close;

		forEach( promos, function ( index, value ) {

			promo_id = value.getAttribute( 'id' );

			promo_cookie = Cookies.get( 'fsc-' + promo_id );

			if ( undefined === promo_cookie ) {

				value.classList.add( 'show-promo' );
				value.setAttribute( 'aria-hidden', 'false' );

			} else {

				value.classList.add( 'hide-promo' );
				value.setAttribute( 'aria-hidden', 'true' );

			} // if/else

			dismiss_button = document.getElementById( 'dismiss-' + promo_id );

			dismiss_button.addEventListener( 'click', function() {

				if ( value.classList.contains( 'show-promo' ) ) {
					value.classList.remove( 'show-promo' );
					value.classList.add( 'hide-promo' );
					value.setAttribute( 'aria-hidden', 'true' );
				}

				promo_id = value.getAttribute( 'id' );

				Cookies.set( 'fsc-' + promo_id, 'dismissed', { expires: 7 } );

			} );

			dismiss_close = document.getElementById( 'close-' + promo_id );

			dismiss_close.addEventListener( 'click', function() {

				if ( value.classList.contains( 'show-promo' ) ) {
					value.classList.remove( 'show-promo' );
					value.classList.add( 'hide-promo' );
					value.setAttribute( 'aria-hidden', 'true' );
				}

			} );

		} ); // forEach

	} // promoCheck()

} // PromoBanner
export default new PromoBanner();



// WEBPACK FOOTER //
// ./assets/components/promo/promo.js